export default __webpack_public_path__ + "68b03f3eec614e236f06aaf19702eae5.svg";